import apiRequestService from '@/commonProject/service/apiRequestService';

export default class DisclosureCounselingRepository {
    /**
     * 開示カウンセリング詳細取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @param {*} idToken
     * @returns result
     */
    async getDisclosureCounselingDetailApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/dscdtl', requestBody, idToken);
        return result;
    }
    /**
     * 開示カウンセリング一覧取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @param {*} idToken
     * @returns result
     */
    async getDisclosureCounselingListApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/dsclst', requestBody, idToken);
        return result;
    }

    /**
     * 開示カウンセリング取消API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @param {*} idToken
     * @returns result
     */
    async deleteDisclosureCounselingApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerDelete(API_URL + '/dscdtl', requestBody, idToken);
        return result;
    }
    /**
     * 開示カウンセリングサービス一覧取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @param {*} idToken
     * @returns result
     */
    async getDisclosureCounselingServiceListApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/dscsvclst', requestBody, idToken);
        return result;
    }
    /**
     * 開示カウンセリング登録API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @param {*} idToken
     * @returns result
     */
    async registDisclosureCounselingApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/dscdtl', requestBody, idToken);
        return result;
    }
    /**
     * 開示カウンセリングレポートAPI
     * @param {String} API_URL
     * @param {Object} requestBody
     * @param {*} idToken
     * @returns result
     */
    async getDisclosureCounselingReportApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/dscrep', requestBody, idToken);
        return result;
    }
}
